module.exports = __webpack_public_path__ + "img/2.1.b246c38d.png";